import { normalizeId } from "./Pool_Utils.js";

class Pool_CartManager {
    constructor(configurator) {
        this.configurator = configurator;
        this.selectedItems = [];
        this.container = document.getElementById("step-6-options");
    }

    /**
     * Renders the cart review step with a confirmation button.
     */
    render() {
        this.container.innerHTML = `
            <h3 class="text-center fw-bold fs-3">Review Your Selection</h3>
            <p class="text-center">If everything looks correct, click "Add to Cart" to proceed.</p>

            <!-- ✅ Inject summary container here -->
            <div id="review-summary" class="mb-4"></div>

            <button id="final-add-to-cart" class="btn btn-success btn-lg w-100 fw-bold">Add to Cart</button>
        `;

        this.injectSummary();
        this.attachCartButtonEvent();
    }

    /**
     * Injects the existing summary content into the review step.
     */
    injectSummary() {
        const reviewSummaryContainer = document.getElementById("review-summary");
        if (!reviewSummaryContainer || !this.configurator.summaryManager) return;
    
        // ✅ Get the summary as HTML and insert it into the Review step
        reviewSummaryContainer.innerHTML = this.configurator.summaryManager.getSummaryHTML(
            this.configurator.state.selectedPool,
            this.configurator.state.selectedLiner,
            this.configurator.state.selectedSkimmer,
            this.configurator.state.selectedEquipment,
            true // ✅ Pass true to mark it as the Review step
        );
    }     

    /**
     * Ensures event listeners are correctly attached after rendering.
     */
    attachCartButtonEvent() {
        const addToCartButton = document.getElementById("final-add-to-cart");
        if (!addToCartButton) return;

        // Replace button to clear old event listeners
        addToCartButton.replaceWith(addToCartButton.cloneNode(true));
        document.getElementById("final-add-to-cart").addEventListener("click", () => this.addItemsToCart());
    }

    /**
     * Updates the cart items based on the user's selection.
     * @param {Object} pool - Selected pool option.
     * @param {Object} liner - Selected liner option.
     * @param {Object} skimmer - Selected skimmer option.
     * @param {Object} equipment - Selected equipment options.
     */
    updateCart(pool, liner, skimmer, equipment) {
        this.selectedItems = [];

        this.addItem(pool?.size?.id, pool?.name, pool?.image, pool?.price);
        this.addItem(liner?.id, `${liner?.name} (${liner?.type})`, liner?.image, liner?.price);
        this.addItem(skimmer?.id, skimmer?.name, skimmer?.image, skimmer?.price);

        this.addEquipmentItems(equipment);

        this.render();
    }

    /**
     * Adds an individual item to the cart.
     * @param {string} id - Shopify variant ID.
     * @param {string} name - Item name.
     * @param {string} image - Item image URL.
     * @param {number} price - Item price.
     */
    addItem(id, name, image, price) {
        if (!id) return;
        this.selectedItems.push({
            id: normalizeId(id),
            name,
            image,
            price: parseFloat(price) || 0,
        });
    }

    /**
     * Adds equipment items (filter and pump) to the cart.
     * @param {Object} equipment - Equipment selection containing filter and pump.
     */
    addEquipmentItems(equipment) {
        if (!equipment) return;

        this.addItem(
            equipment.filter?.variants?.[0]?.id,
            equipment.filter?.name,
            equipment.filter?.image,
            equipment.filter?.variants?.[0]?.price
        );

        this.addItem(
            equipment.pump?.variants?.[0]?.id,
            equipment.pump?.name,
            equipment.pump?.image,
            equipment.pump?.variants?.[0]?.price
        );
    }

    /**
     * Sends selected items to Shopify's cart API.
     */
    addItemsToCart() {
        const cartItems = this.selectedItems
            .filter(item => item.id) // Ensure valid items only
            .map(item => ({ id: normalizeId(item.id), quantity: 1 }));

        fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: cartItems }),
        })
        .then(response => response.ok ? response.json() : response.json().then(error => Promise.reject(error)))
        .then(() => window.location.href = "/cart")
        .catch(error => {
            alert("Error adding to cart. Please try again.");
            console.error("Shopify API Error:", error);
        });
    }
}

export { Pool_CartManager };
